export default __webpack_public_path__ + "static/media/af-main-logo.dd73282f.svg";